module.exports = __webpack_public_path__ + "img/leg1.0ab1a031.png";